
import React, { Component } from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import { IconButton } from '../../../'

/**
 * @class: FinisOrderDIAModal
 */

class FinisOrderDIAModal extends Component {


  static defaultProps = {
    isOpen: true
  }

  constructor (...args) {
    super(...args)
  }

  render () {
    return ( this.renderContent() )
  }


  renderContent () {
    const { customClassName } = this.props
    return (
      <div ref="modal" role="dialog">
                <iframe width={'1200'} height={'900'} src={this.props.url}></iframe>
      </div>

    )
  }
}



export default FinisOrderDIAModal
